<template>
  <div class="image-code">
    <img :src="imageCodeUrl" alt="点击切换验证码" title="点击切换验证码" @click="changeImageCode">
  </div>
</template>

<script>
import { getImageCode } from '@/api/base'
export default {
  name: 'ImageCode',
  data() {
    return {
      sessionId: '',
      imageCodeUrl: ''
    }
  },
  methods: {
    // 切换验证码
    changeImageCode() {
      this.sessionId = Math.random()
        .toString(36)
        .substr(2)
      this.imageCodeUrl = getImageCode(this.sessionId)
      this.$emit('input', this.sessionId)
    }
  },
  created() {
    this.changeImageCode()
  }
}
</script>
<style>
</style>
